import { render, staticRenderFns } from "./Portfolio_openpositions.vue?vue&type=template&id=77b68112&scoped=true&"
import script from "./Portfolio_openpositions.vue?vue&type=script&lang=js&"
export * from "./Portfolio_openpositions.vue?vue&type=script&lang=js&"
import style0 from "./Portfolio_openpositions.vue?vue&type=style&index=0&id=77b68112&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b68112",
  null
  
)

export default component.exports